import { useEffect, useState } from "react";
import { isConsentRequiredRegion, acceptConsent, rejectConsent, hasConsentChoice } from "@/lib/consent";

/**
 * Cookie-Banner für Consent-Mode-v2.
 *
 * Erscheint nur für Besucher aus Einwilligungsregionen (EEA, UK, CH, CA),
 * die noch keine Wahl getroffen haben. Akzeptieren aktiviert das vollständige
 * Google-Ads-Tracking; Ablehnen respektiert die Entscheidung.
 */
export function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (hasConsentChoice()) return;
    let cancelled = false;
    isConsentRequiredRegion().then((required) => {
      if (!cancelled && required) setShow(true);
    });
    return () => { cancelled = true; };
  }, []);

  // Auf anderen Tabs geänderte Wahl übernehmen
  useEffect(() => {
    if (!show) return;
    const handler = (e: StorageEvent) => {
      if (e.key === "cookie_consent") setShow(false);
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [show]);

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie-Einwilligung"
      className="fixed inset-x-0 bottom-0 z-[100] p-3 md:p-4"
    >
      <div className="mx-auto flex max-w-2xl flex-col gap-3 rounded-2xl border border-border/70 bg-card/95 p-4 shadow-lift backdrop-blur-md md:flex-row md:items-center md:gap-4 md:p-5">
        <p className="flex-1 text-sm leading-relaxed text-muted-foreground">
          Diese Website nutzt Google Ads und Analytics, um die Wirksamkeit von
          Anzeigen zu messen. Mit Klick auf „Zustimmen" erlauben Sie die
 Verwendung von Cookies für Werbung und Analyse. Sie können die
          Einwilligung jederzeit widerrufen. Details in der{" "}
          <a
            href="/datenschutz"
            className="text-primary underline underline-offset-4 hover:opacity-80"
          >
            Datenschutzerklärung
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={() => { rejectConsent(); setShow(false); }}
            className="rounded-xl border border-border bg-transparent px-4 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-accent"
          >
            Ablehnen
          </button>
          <button
            onClick={() => { acceptConsent(); setShow(false); }}
            className="rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-signal transition-all hover:-translate-y-0.5 hover:shadow-signal"
          >
            Zustimmen
          </button>
        </div>
      </div>
    </div>
  );
}
